module.exports = __webpack_public_path__ + "static/img/redforestal.c56d9b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/redforestal.svg
// module id = TJlL
// module chunks = 1